import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box, useTheme } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AddProperty from './pages/AddProperty';
import EditProperties from './pages/EditProperties';
import EditProperty from './pages/EditProperty';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import EnvTest from './components/EnvTest';
import theme from './theme';

function AppContent() {
  const location = useLocation();
  const currentTheme = useTheme();
  
  // Check if current route is login or register
  const isAuthPage = ['/login', '/register', '/reset-password'].includes(location.pathname);

  return (
    <Box className="App" sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          pt: { xs: 8, sm: 10 },
          backgroundColor: isAuthPage ? currentTheme.palette.background.default : 'inherit',
          transition: 'background-color 0.3s ease-in-out'
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:id" element={<PropertyDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/test-env" element={<EnvTest />} />
          {/* Supabase test routes disabled - using custom API routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/add-property" 
            element={
              <ProtectedRoute>
                <AddProperty />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/edit-properties" 
            element={
              <ProtectedRoute>
                <EditProperties />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/edit-property/:id" 
            element={
              <ProtectedRoute>
                <EditProperty />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <AppContent />
        </AuthProvider>
        <Analytics />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
